<template>
    <div>
        <el-row>
            <el-col :span="2"><div class="grid-content"></div></el-col>
            <el-col :span="20">
                <div class="title">
                    <h1> Product creativity design tool (WebApp)</h1>
                </div>
                <div class="video">
                    <div class="">
                        <video src="../assets/CC.mp4" controls muted >
                        OMG! Where is my video?
                        </video>
                    </div>
                </div>
                <div class="abstract">
                    In the process of conceptual design of service robot, the theory of “Value Linkage” is introduced, a user-centered conceptual
                    design framework is constructed, and a design decision-making method combining qualitative and quantitative is proposed to help
                    designers efficiently develop the product concept of service robot with specific cultural characteristics. On this basis, a web-based
                    design tool is developed, and designers are invited to use the tool for design practice to verify the effectiveness of the design framework
                    and decision-making method. The results show that this method can effectively support the designer's creative output in the conceptual
                    design stage, and has good knowledge carrying and creative stimulation ability, but the ease of use of design tools still needs to be
                    improved. In the future, the method and tool can be extended and applied to the design field where more design objects and cultural
                    attributes are integrated.
                </div>
            </el-col>
            <el-col :span="2"><div class="grid-content"></div></el-col>
        </el-row>
        <el-row :gutter="40" style="margin-top: 50px">
            <el-col :span="2"><div class="grid-content"></div></el-col>
            <el-col :span="8">
                <div class="picture">
                    <img src="../assets/project7_1.png.webp">
                </div>
            </el-col>
            <el-col :span="12">
                <div class="sub-title">
                    Conceptual Design Framework from the Perspective of "Value Linkage" Theory
                </div>
                <div class="text">
                    Max Weber's theory of "value correlation" states that the value of this world to every individual is due to a value attitude towards the world. If an individual does not express themselves to the world, then the world of life, no matter how rich and colorful, is of no value to him. Since the mid-1980s, cultural psychology has inherited the theory of "value correlation" and began to emphasize that culture is not an external determinant of human psychological behavior, but an internal presence of human awareness, understanding, and action. In other words, cultural psychology views the human mind as content driven, domain specific, environmental structured, historically changing, and culturally diverse. Among them, the cultural psychology theory of SHWEDER. R.A has a certain representativeness. He pointed out that "culture" refers to the intentional world, and the premise of the existence of the intentional world is that the intentional person seizes meaning or resources from it, and cannot exist independently. The cultural psychology concept of interdependence between the intentional world and intentional people proposed by SHWEDER. R.A can be seen as a concrete manifestation of the "value correlation" theory in cultural psychology, which studies the process of people producing products when they extract meaning or resources from the intentional world. The intentional world is an important research content. From the perspective of "value correlation", cultural resources and service robot products are both the results of intentional individuals grabbing meaning and resources from a certain intentional world. In conceptual design, intentionality refers to the intended user (or target user), the process of capturing meaning and resources is the process of generating intention, and the captured meaning and resources are the user motivation. From the perspective of value correlation, "intentional individuals" are the core and key to everything, which is also in line with the user centered design principle.
                </div>
            </el-col>
            <el-col :span="2"><div class="grid-content"></div></el-col>
        </el-row>
        <el-row :gutter="40" style="margin-top: 50px">
            <el-col :span="2"><div class="grid-content"></div></el-col>
            <el-col :span="12">
                <div class="sub-title">
                    MIS framework
                </div>
                <div class="text">
                    Therefore, designing a service robot with distinct cultural attributes is an effective way to connect and integrate two intentional worlds, becoming a new and integrated intentional world. Integrating two intentional worlds requires consideration of the following issues:

                    <br><br>(1) Is there a common user motivation (represented by the letter M in this study, which is taken from Motivation);

                    <br><br>(2) Does the user have a certain degree of intention towards the intentional world (represented by the letter I in this study, which is taken from Intention);

                    <br><br> (3) Is there any similarity in the process of user intention generation (represented by the letter S in this study, S taken from Similarity)

                    <br><br>This conceptual design framework emphasizes that product concepts are jointly influenced by M, I, and S, hence it is referred to as the MIS framework in this study.
                </div>
            </el-col>
            <el-col :span="8">
                <div class="picture">
                    <img src="../assets/project7_2.png.webp">
                </div>

            </el-col>
            <el-col :span="2"><div class="grid-content"></div></el-col>
        </el-row>
        <el-row :gutter="40" style="margin-top: 50px">
            <el-col :span="2"><div class="grid-content"></div></el-col>
            <el-col :span="8">
                <div class="picture">
                    <img src="../assets/project7_3.png.webp">
                    <img src="../assets/project7_4.png.webp">
                    <img src="../assets/project7_5.png.webp">
                </div>
            </el-col>
            <el-col :span="12">
                <div class="sub-title">
                    Conceptual Design Decision Method Based on Fuzzy Analytic Hierarchy Process
                </div>
                <div class="text">
                    According to the process of Fuzzy Analytic Hierarchy Process, the decision-making process of the product conceptual design process is first decomposed into three levels: target layer, criterion layer, and measure layer (as shown in Figure 3). The importance analysis of product definition (A) serves as the target layer in this analysis. Based on the definition of the MIS conceptual design framework, the criterion layer serves as the three dimensions for evaluating the importance of the final product definition: user motivation (M), intention degree (I), and similarity in the intention generation process (S). Product definition (D) is the ultimate analysis objective, serving as the measure layer. If specific items in the product definition, such as appearance style, material, usage, etc., are represented by the letter P, then D={P 1, P2, P3... Pi}.

                   <br><br> Under the MIS framework, this study introduces the fuzzy analytic hierarchy process (fuzzy consistency judgment matrix) to solve the decision-making problem of final product definition. Fuzzy Analytic Hierarchy Process, as a combination of quantitative and qualitative methods, can standardize the subjective elements in the design process in a mathematical and physical manner. By calculating the scores of different product definition items P on the M, I, and S dimensions, the weight vector {W_ {mis} ^ T of product definition D can be obtained to determine each product definition item P_ The importance of i to provide effective guidance for the designer's final design process.

                    This study used the Java Matrix Operation Package (JAMA) to perform matrix operations related to Fuzzy Analytic Hierarchy Process. JAMA can be more easily integrated with web projects, laying the foundation for future design tool development.

                    <br><br>This study invited 12 designers (all with more than two years of design professional learning experience) to conduct a seminar with the aim of understanding the weights of the M, I, and S dimensions. During the experiment, the researchers first introduced the concepts of three dimensions and the design process guided by the MIS conceptual design framework to the designers. Designers were asked to use this framework for a service robot conceptual design within 14 days. After the design was completed, the designers were asked to rank the impact of the design concepts from three dimensions. Based on the ranking results, the conclusion was drawn that S>I>M, Therefore, this study established a fuzzy consistency judgment matrix (first level fuzzy consistency judgment matrix) for product definition importance analysis (A) as shown in equation (1).
                    <br><br>The value 1 indicates that the importance of the two factors is consistent, 2 indicates that the importance of the factor is slightly higher than that of the other factor, and 3 indicates that the importance of the factor is significantly higher than that of the other factor.

                    This study uses the eig() function in Jama to calculate the eigenvalues and eigenvectors of the matrix (the calculation process is similar to that described in 3.2). Calculated maximum eigenvalue, lambda_ {max}=3.0055, the corresponding eigenvector is left [ begin {matrix}0.26 \\0.47 0.85 end {matrix} right], the final weight is {W_a} ^ T= left [ begin] {matrix}0.16 &0.30&0.54 end {matrix} right].

                    The consistency check formula is shown in equation (2), where n is the matrix order of equation (1), i.e. n=3. It is calculated that the fuzzy consistency judgment matrix meets the consistency requirement (CI = 0.0028 is smaller than 0.1), indicating that the obtained weight {W_a} ^ T is valid.
                </div>
            </el-col>
            <el-col :span="2"><div class="grid-content"></div></el-col>
        </el-row>
        <el-row :gutter="40" style="margin-top: 50px">
            <el-col :span="2"><div class="grid-content"></div></el-col>
            <el-col :span="12">
                <div class="sub-title">
                    Measure layer weight calculation: MIS value
                </div>
                <div class="text">
                    Firstly, establish a fuzzy consistency judgment matrix for the importance of product definition. This study used {PM}_i , {PI}_i And {PS}_i Represents the scores of each product definition in the dimensions of M, I, and S. i represents the number of the product definition. The fuzzy consistency judgment matrix of M is shown in equation (3), and I is the same as S and M.
                    <br><br>For the purpose of simplifying calculations and focusing more on verifying the feasibility of the method, combined with the principle of the Likert 5-point scale, this study assigns all numbers that need to be assigned by the designer to five levels, with values of 1,3,5,7,9, respectively
                    <br><br>{PM}_i The user motivation level defined by this product (determined by user research) {PM}_i ={1,3,5,7,9}

                    <br><br>{PI}_i The intention level of this product definition (determined by user research) {PI}_i ={1,3,5,7,9}

                    <br><br> {PS}_i The number of similar product requirement items and cultural resource feature items based on which the product definition is generated (determined by the designer) (n represents the actual number of similar items), {PS}_i =1 (n=0,1,2,3), {PS}_i =3 (n=4,5,6), {PS}_i =5 (n=7,8,9), {PS}_i =7 (n=10,11,12), {PS}_i =9 (n=13,14,15)

                    <br><br>   By calculation, the weight vector ({W_ {mis}} ^ T) of the product definition (D) will be obtained. The weight of the specific item (P_i) of the product definition corresponds to each element in the {W_ {mis}} ^ T matrix in sequence. The larger the element value, the higher the importance of the product definition. This study names each element of {W_ {mis}} ^ T obtained from the final calculation of the measure layer P_ The 'MIS value' of i.

                </div>
            </el-col>
            <el-col :span="8">
                <div class="picture">
                    <img src="../assets/project7_6.png.webp">
                    <img src="../assets/project7_7.png.webp">
                    <img src="../assets/project7_8.png.webp">
                </div>

            </el-col>
            <el-col :span="2"><div class="grid-content"></div></el-col>
        </el-row>

    </div>
</template>

<script>
    export default {
        name: "Project7"
    }
</script>

<style scoped>
    .picture img{
        width: 100%;
    }
    .sub-title{
        margin-bottom: 20px;
        font-size: 15px;
        color: #666;
        font-weight: 400;
        text-align: justify;
    }
    .text{
        font-size: 15px;
        color: #333;
        font-weight: 100;
        text-align: justify;
    }
    .abstract{
        margin-top: 40px;
        font-size: 15px;
        color: #333;
        font-weight: 100;
        text-align: justify;
    }
    video{
        width: 100%;
    }
    .grid-content{
        min-height: 36px;
    }
    .video{
        margin-top: 100px;
    }
    .title{
        margin-top: 100px;
        text-align: center;

    }
    .title a{
        color: #333;
    }
    .title p{
        color: #aaa;
        line-height: 30px;
    }
    .title h1{
        font-size:30px;
        font-weight: 100;
        letter-spacing:6px;
        color: #333333;
    }
</style>